/* eslint-disable xss/no-mixed-html */
ACC.abandoncart = {
  hideCls: 'hidden',
  overlayCls: '.ph-popup_overlay',
  showAbandonCartPopup: function() {
    $.colorbox({
      maxWidth: '630px',
      width: '95%',
      height: 'auto',
      scrolling: true,
      html: $('.ph-abandoncart_popup').html(),
      escKey: false,
      overlayClose: false,
      onLoad: function() {
        $('#cboxClose').remove();
      },
      onClosed: function() {
        ACC.common.refreshScreenReaderBuffer();
      }
    });
  },
  showNoProductsPopup: function() {
    var popupWidth = '40%',
        popupHeight = '170px';

    if ($(window).width() < 1024) {
      popupWidth = '95%';
    }

    if ($(window).width() < 768) {
      popupHeight = '200px';
    }

    $.colorbox({
      maxWidth: '630px',
      width: popupWidth,
      height: popupHeight,
      scrolling: true,
      html: $('.ph-abandoncart_noproducts_popup').html(),
      overlayClose: false,
      onLoad: function() {
        $('#cboxClose').remove();
      },
      onClosed: function() {
        ACC.common.refreshScreenReaderBuffer();
      }
    });
  },
  addProductsFromCookieToCart: function(isModified, productList) {
    $.ajax({
      url: ACC.config.encodedContextPath + '/cart/add/multiple',
      data: {
        products: productList.toString()
      },
      type: 'POST',
      Datatype: 'json',
      success: function(cartResult) {
        var addToCartLayerId = '#addToCartLayer',
            loader = 'cont-loader',
            disableButn = '.ph-cart-interstitial,.ph-interstitial-checkout-btn,.ph-interstitial-checkout-btnMob';

        $(ACC.abandoncart.overlayCls).addClass(ACC.abandoncart.hideCls);
        $('.ph-' + loader).addClass(ACC.abandoncart.hideCls);
        $('.ph-decisionpage__bottomcontent').css('pointer-events', 'auto');
        $(disableButn).attr('disabled', false).removeClass('ph-disable-button');

        if (cartResult.miniCartCount) {
          $('#miniCartIcon').html('<div class="quantity-balloon"></div>');
          $('#miniCartIcon .quantity-balloon').html(cartResult.miniCartCount);
          ACC.minicart.$layer.data('needRefresh', true);
        }

        $('#header').append(cartResult.addToCartLayer);
        clearTimeout(window.sto);

        if (isModified === true) {
          $('.ph-abndoncart-message').removeClass(ACC.abandoncart.hideCls);
        }

        $(addToCartLayerId).fadeIn(function() {
          $.colorbox.close();

          setTimeout(function() {
            $(addToCartLayerId).fadeOut(function() {
              $('#header #addToCartLayer').remove();
            });
          }, 5000);
        });

        if (!$('.ph-popup_overlay').is(':visible')) {
          $('.ph-support-contact-details-default').css('z-index', 3004);
        }

        $('body,html').animate({
          scrollTop: 0
        }, 400);
      }
    });
  }
};
$(document).ready(function() {
  var pageNameLbl = $('#ph-pageType').val(),
      storeClosed = $('.ph-storeclosed').val(),
      cartExist = $('.ph-cartExist').val();

  $(document).on('click', '.ph-abandoncart-restorecart', function() {
    $(ACC.abandoncart.overlayCls).removeClass(ACC.abandoncart.hideCls);
    $.ajax({
      url: ACC.config.encodedContextPath + '/asyncproduct/validateAbandonedCart',
      type: 'GET',
      datatype: 'json',
      success: function(result) {
        if (result.products.length === 0) {
          $(ACC.abandoncart.overlayCls).addClass(ACC.abandoncart.hideCls);
          ACC.abandoncart.showNoProductsPopup();
        } else {
          ACC.abandoncart.addProductsFromCookieToCart(result.isModified, result.products);
          $.colorbox.close();

          if ($('.ph-popup_overlay').is(':visible')) {
            $('.ph-support-contact-details-default').css('z-index', 3);
          }
        }
      },
      error: function() {
        $(ACC.abandoncart.overlayCls).addClass(ACC.abandoncart.hideCls);
      }
    });
  });
  $(document).on('click', '.ph-abandoncart-clearcart', function() {
    $(ACC.abandoncart.overlayCls).removeClass(ACC.abandoncart.hideCls);
    $.ajax({
      url: ACC.config.encodedContextPath + '/asyncproduct/invalidateAbandonedCart',
      type: 'POST',
      datatype: 'json',
      success: function() {
        $.colorbox.close();
        $(ACC.abandoncart.overlayCls).addClass(ACC.abandoncart.hideCls);
      },
      error: function() {
        $(ACC.abandoncart.overlayCls).addClass(ACC.abandoncart.hideCls);
      }
    });
  });
  $(document).on('click', '.ph-abandoncart-okbutton', function() {
    $.colorbox.close();
  });

  if (pageNameLbl) {
    if (cartExist === 'true' && $('.ph-sap-orderBlock').length === 0 && storeClosed !== 'true') {
      ACC.abandoncart.showAbandonCartPopup();
    }
  }
});
/* eslint-enable xss/no-mixed-html */
